import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const DryBlendIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-dryBlend"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M42.042 0a1 1 0 0 1 .955.925l.002.117L41.96 26H22.041L21 1.042a1 1 0 0 1 1.987-.2l.011.116L23.96 24H40.04L41 .958a1 1 0 0 1 .925-.955z"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M41.883 24H22.117l-1.25 10h22.266zm-1.767 2 .75 6H23.133l.75-6z"
        />
        <path
          fill="#ffffff"
          className={styles.white}
          d="M33.5 29a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 33.5 29"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M32 27a2 2 0 1 0 .001 4.001A2 2 0 0 0 32 27m0 1a1 1 0 1 1-.001 2.001A1 1 0 0 1 32 28M45 6a1 1 0 0 1 .117 1.993L45 8h-3a1 1 0 0 1-.117-1.993L42 6z"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M46 4a1 1 0 0 1 .993.883L47 5v10a1 1 0 0 1-1.993.117L45 15V5a1 1 0 0 1 1-1"
        />
        <path
          fill="#0050B3"
          className={styles.interactiveColor}
          fillRule="nonzero"
          d="M26.976 12.6c.161.493.396.922.687 1.291.2.255.413.466.624.635l.13.099.124.081-.49.872c-.31-.174-.745-.521-1.175-1.07a5.2 5.2 0 0 1-.743-1.3l-.107-.297z"
        />
        <path
          fill="#0050B3"
          className={styles.interactiveColor}
          fillRule="nonzero"
          d="m25.192 13.113 3.287 1.669-.453.892-3.287-1.669z"
        />
        <path
          fill="#0050B3"
          className={styles.interactiveColor}
          fillRule="nonzero"
          d="M25.073 14.787a5.03 5.03 0 0 1 3.096-.035l.185.066.068.03-.415.91-.09-.036-.15-.047-.094-.026a4 4 0 0 0-2.041.015l-.248.074z"
        />
        <path
          fill="#ffffff"
          className={styles.white}
          d="m37.58 21.426.244-.391a1.17 1.17 0 0 0-.289-1.55l-7.496-5.646a1.166 1.166 0 0 0-1.692.315l-1.123 1.802a1.17 1.17 0 0 0 .464 1.658l8.375 4.236a1.166 1.166 0 0 0 1.517-.424"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M27.922 13.89 26.8 15.69c-.518.83-.21 1.926.662 2.369l8.375 4.236c.77.39 1.712.127 2.168-.606l.243-.39a1.67 1.67 0 0 0-.412-2.213L30.34 13.44a1.666 1.666 0 0 0-2.418.45m1.816.348 7.496 5.647a.67.67 0 0 1 .165.886l-.243.39a.666.666 0 0 1-.867.243l-8.375-4.236a.67.67 0 0 1-.266-.948l1.123-1.802a.666.666 0 0 1 .967-.18"
        />
        <path
          fill="#ffffff"
          className={styles.white}
          d="M37.493 8c0 .085.385 4.5-4.496 4.5A4.5 4.5 0 0 1 28.5 8c0-2.485 2.013-4.5 4.497-4.5A4.5 4.5 0 0 1 37.493 8"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M32.997 4a4 4 0 0 1 3.991 3.8l.009.296a4.3 4.3 0 0 1-.363 1.948C36.081 11.272 34.956 12 32.997 12A4 4 0 0 1 29 8c0-2.21 1.79-4 3.997-4m4.999 4.054L37.993 8c0-2.761-2.237-5-4.996-5A5 5 0 0 0 28 8c0 2.761 2.237 5 4.997 5 2.353 0 3.834-.96 4.549-2.545.375-.832.48-1.667.45-2.4"
        />
        <path
          fill="#0050B3"
          className={styles.interactiveColor}
          d="M31.802 1.199c.885.884.776 1.846.8 2.403-.557-.023-1.518.085-2.403-.8-.886-.885-.777-1.846-.802-2.404.559.023 1.52-.085 2.405.8m2.713 1.44c-.753.752-1.458.771-1.878.847.076-.42.095-1.126.848-1.878.752-.753 1.458-.772 1.878-.848-.076.42-.095 1.125-.848 1.878"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M32.5 3a.5.5 0 0 1 .492.41L33 3.5v1a.5.5 0 0 1-.992.09L32 4.5v-1a.5.5 0 0 1 .5-.5"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          d="M31 9.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m2 1a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m-1-3a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
        />
      </g>
    </Icon>
  )
}
